module.exports = __webpack_public_path__ + "static/icons/icon-gear-805bb49cbfbde4abe6a7ba4455bb220a.svg";